"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    complimentaryDrinks: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string.isRequired,
      name: _propTypes.string.isRequired,
      checkRequired: _propTypes.bool,
      count: _propTypes.number,
      price: _propTypes.number.isRequired,
      currency: _propTypes.string,
      discount: _propTypes.number,
      slashedPrice: _propTypes.number,
      isSelected: _propTypes.bool,
      isIncluded: _propTypes.bool,
      imageUrl: _propTypes.string
    })),
    isDisabled: _propTypes.bool,
    onChangeDrinks: _propTypes.func,
    isMobile: _propTypes.bool,
    maxDropdownHeight: _propTypes.number,
    currency: _propTypes.string
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    isDisabled: false,
    complimentaryDrinks: [],
    isMobile: false,
    maxDropdownHeight: 256,
    onChangeDrinks: function onChangeDrinks() {}
  }
};
exports.default = _default;